<!-- Basic Inputs start -->
<div class="modal-header bg-primary">
    <h4 class="modal-title">Notificação Time Contazz</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        x
    </button>
</div>
<div class="modal-body ">
    <div>

        <div class="col-12">

            <div class="row">
                <div class="col-xl-8 col-lg-6 col-md-12 mb-1">
                    <label for="txtValue">Titulo</label>
                    <input type="text" class="form-control" id="" [value]="request.title" disabled />
                </div>

                <div class="col-xl-4 col-lg-6 col-md-12 mb-1">
                    <label for="txtDate">Data</label>
                    <input id="txtDate" class="form-control" type="datetime-local" [value]="request.creationDate"
                        disabled />
                </div>

                <div class="col-xl-12 col-lg-12 col-md-12 mb-1">
                    <fieldset class="form-group">
                        <label for="txtName">Descrição</label>
                        <textarea class="form-control" aria-label="With textarea" rows="2" disabled
                            [value]="request.description"></textarea>
                    </fieldset>
                </div>



            </div>


            <div class="d-flex justify-content-between">

                <div>
                    <input type="file" id="fileInput" class="custom-file-input" hidden (change)="upload($event)">
                    <label for="fileInput" class="btn btn-raised btn-primary" *ngIf="document == null">
                        Anexar
                    </label>
                    <span class="primary" *ngIf="document != null">{{file.name}}</span>
                </div>

                <button type="submit" class="btn btn-raised btn-outline-primary" (click)="toRequest()">Adicionar
                    comentário</button>

            </div>

            <div class="d-flex justify-content-center mt-2">

                <button type="submit" class="btn btn-raised btn-outline-primary"
                    (click)="activeModal.dismiss('Cross click')">Fechar</button>
                <button type="submit" class="btn btn-raised btn-primary ml-2" (click)="addComment()">Enviar</button>

            </div>
        </div>

    </div>
</div>